import { ActionReducerMap } from '@ngrx/store';
import { CashbookViewColumnViewModelStates } from '../states';
import * as fromColumn1ViewModelReducers from './column_1_view_model.reducers';
export const columnViewModelFeatureKey = 'genericDocCashbookViewModel';
export const columnViewModelReducers: ActionReducerMap<CashbookViewColumnViewModelStates> = {
  column1ViewModel: fromColumn1ViewModelReducers.reducer,
};